module.exports = "/fonts/fa-light-300.eot?d04e7c7a32ec3df6ee6cad38f99e4f2c";